module.exports = __webpack_public_path__ + "static/icons/icon-airport-transfers-07fcfaa3bc2ae387e190252d79ab5f27.svg";